import React from "react";
import {
  Box,
  Modal,
  Typography,
  Chip,
  Button,
  IconButton,
  Card,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Fade from "@mui/material/Fade";
import { useNavigate } from "react-router-dom";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "92%", sm: "500px", md: "650px" },
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "rgba(255,255,255,0.95)",
  backdropFilter: "blur(12px)",
  boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
  borderRadius: "18px",
  p: 0,
};

function CourseDetailsModal({ open, handleClose, course }) {
  const navigate = useNavigate();

  if (!course) return null;

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <Card sx={modalStyle}>

          {/* ❌ CROSS BUTTON */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              bgcolor: "rgba(255,255,255,0.7)",
              backdropFilter: "blur(6px)",
              "&:hover": { bgcolor: "rgba(230,230,230,0.9)" },
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* IMAGE — FULLY VISIBLE, NO CROP */}
          <Box
            sx={{
              width: "100%",
              maxHeight: { xs: "220px", sm: "370px" },
              overflow: "hidden",
              borderTopLeftRadius: "18px",
            //   borderBottomRightRadius: "18px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "#f5f5f5",
            }}
          >
            <img
              src={course.coursePic}
              alt={course.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain", // ← FULL image visible
              }}
            />
          </Box>

          {/* CONTENT */}
          <Box sx={{ p: { xs: 2.5, sm: 3 } }}>
            {/* TITLE */}
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                textAlign: "center",
                color: "#1A1A1A",
                fontSize: { xs: "1.25rem", sm: "1.6rem" },
              }}
            >
              {course.name}
            </Typography>

            {/* DESCRIPTION */}
            <Typography
              sx={{
                mt: 1.5,
                textAlign: "center",
                color: "#555",
                lineHeight: 1.6,
                fontSize: { xs: ".9rem", sm: "1rem" },
              }}
            >
              {course.description}
            </Typography>

            {/* PREREQUISITES */}
            {course.prerequisites?.length > 0 && (
              <Box sx={{ mt: 3 }}>
                <Typography
                  sx={{ fontWeight: 600, mb: 1, color: "#2c3e50" }}
                >
                  Prerequisites
                </Typography>

                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {course.prerequisites.map((p, i) => (
                    <Chip
                      key={i}
                      label={p}
                      sx={{
                        background: "#efefef",
                        fontSize: ".8rem",
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}

            {/* DURATION */}
            <Typography sx={{ mt: 3, fontSize: "1rem" }}>
              <strong>Duration:</strong> {course.duration.value}{" "}
              {course.duration.unit}
            </Typography>

            {/* FEES (DB STRUCTURE BASED) */}
            <Box sx={{ mt: 2 }}>
              {course.feeStructure?.baseFee &&
                course.feeStructure.discount > 0 && (
                  <Typography
                    sx={{
                      textDecoration: "line-through",
                      color: "gray",
                      fontSize: ".95rem",
                    }}
                  >
                    ₹{course.feeStructure.baseFee}
                  </Typography>
              )}

              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.6rem",
                  color: "#111",
                }}
              >
                ₹{course.feeStructure.finalFee}
              </Typography>
            </Box>

            {/* STICKY BUTTONS */}
            <Box
              sx={{
                mt: 4,
                display: "flex",
                gap: 2,
                position: "sticky",
                bottom: 0,
                pt: 2,
                pb: 1,
              }}
            >
              <Button
                fullWidth
                variant="contained"
                onClick={() => navigate("/admission")}
                sx={{
                  borderRadius: "26px",
                  bgcolor: "#000",
                  "&:hover": { bgcolor: "#222" },
                }}
              >
                Start Career Journey
              </Button>
            </Box>
          </Box>
        </Card>
      </Fade>
    </Modal>
  );
}

export default CourseDetailsModal;
